import { IComponentOptions } from "angular";
import { ProgressivesGridComponentController } from "./controller";

export const vsName = "machinesProgressivesGrid";

export const machineProgressivesGridComponentOptions: IComponentOptions = {
  controller: ProgressivesGridComponentController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {},
};
